/** Keep in sync with `.drawerContent` max-height in `page.module.css`. */
export const POINT_DRAWER_MAX_HEIGHT_PX = 460;
export const POINT_DRAWER_VIEWPORT_RATIO = 0.54;

export function getPointDrawerMaxHeightPx(
  viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 800,
): number {
  return Math.round(
    Math.min(
      POINT_DRAWER_MAX_HEIGHT_PX,
      viewportHeight * POINT_DRAWER_VIEWPORT_RATIO,
    ),
  );
}

/** @deprecated Use getPointDrawerMaxHeightPx */
export function getPointDrawerHeightPx(
  viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 800,
): number {
  return getPointDrawerMaxHeightPx(viewportHeight);
}
